"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLength = void 0;
const getLength = (string, options = {
    maxSpaceInARow: 2,
}) => {
    if (typeof string === 'undefined') {
        return 0;
    }
    let preparedString = String(string).trim();
    const regex = new RegExp(`[\\s,&nbsp;]{${options.maxSpaceInARow},}`, 'g');
    preparedString = preparedString.replace(regex, ' '.repeat(options.maxSpaceInARow));
    return preparedString.length;
};
exports.getLength = getLength;
